<template>
    <div class="container mainContainer clearfix padding0">
        <div :id="sidebar_id" class="sideMenuComponent clearfix padding0"
             :style="`width: ${intDefMenuWidth}px; z-index: 0; padding-right: inherit;`"
             :class="`${addClass} col-${left}`">
            <div class="shadowLine" style="opacity: 0;"></div>
            <nav id="menu">
                <div class="sideMenuHeader" ref="router-collapsible" v-on:click="handleHeaderClick"><i class="fa fa-bars"></i>{{lang('toggle_menu')}}</div>
                <div class="sideMenuTreeMenu">
                    <np-tree-menu
                            v-for="(tree, index) in trees"
                            :metadata="tree.metadata"
                            :nodes="tree.nodes"
                            :current-route="currentRoute"
                            :depth="0"
                            ref="treeMenu"
                            :key="`tree_${index}`">
                    </np-tree-menu>
                </div>
            </nav>
        </div>
        <div :id="`${sidebar_id}_content`" :class="`col-${right}`" style="padding: 0px">
            <slot name="main_content"></slot>
        </div>
    </div>
</template>

<script>
    import {SideBar} from '../../entities/sidebar_class'
    import {NPTreeMenu} from "./index";
    import componentEventBus from './event_bus';
    export default {
        name: "np-router-collapsible",
        props: {
            sidebar_id: '',
            trees: {},
            appendUrl: {
                default: ''
            },
            addClass: {
                default: ''
            },
            currentRoute: {
                default: ''
            },
            iconWidth: {default: 37},
            is_toggling: {default: false}, //icon_only feature
            split: {
                default: 0.166667 // determines width of maintabs and buttons
            },
            realpath: {
                type: Boolean,
                default: false,
                note: 'Tells what kind of links to look for in setting Active content, real links or #strings'
            },
            rowFull: {
                type: Boolean,
                default: true,
                note: 'add row to starting div. If nesting a second sidebar, pass row-full as false'
            },
            vueRouter: {
                default: true,
                note: 'defines if vue-router is used on page'
            }
        },
        components: {
            'np-tree-menu': NPTreeMenu
        },
        data: function () {
            return {
                level_2: false,
                tab_data: [],
                intDefMenuWidth: 200,
                intDefMenuMarginTop: -14,
                open_menu: true,
            }
        },
        mounted: function () {

            let vm = this;
            $(function () {
                let targetWidth = vm.type === 'icon_only' ? vm.iconWidth : 200;

                let objID = '#' + vm.sidebar_id;
                $(objID + '_content').css({
                    width: 'calc(100% - ' + targetWidth + 'px)',
                    "padding-left": "inherit",
                    "padding-right": "inherit",
                })

            })
            componentEventBus.on('treechildclick', this.handleChildClick)
        },
        computed: {
            urls: function () {
                return window.location.pathname;
            },

            _split: function () {
                if (isNaN(this.split)) {
                    return 0.6;
                } else {
                    return this.split;
                }
            },
            left: function () {
                return Math.round(12 * this._split)
            },
            right: function () {
                return 12 - this.left;
            },
        },
        methods: {
            handleHeaderClick: function () {
                let vm = this;

                vm.toggleMenu();
                if (!vm.open_menu) {
                    this.$refs.treeMenu.forEach(obj => {
                        obj.showChildren = false;
                    })
                }

                this.$emit('headerclick', vm.sidebar_id);
            },
            handleChildClick: function(data){
                let vm = this;
                if (!vm.open_menu){
                    vm.toggleMenu();
                }
            },
            toggleMenu: function () {
                let vm = this,
                    objID = '#' + vm.sidebar_id,
                    targetWidth = 33,
                    objMenuBlock = $(objID + '.sideMenuComponent'),
                    treeMenu = $(objID + ' .sideMenuTreeMenu'),
                    slotContentBlock = $(objID + '_content'),
                    animation_time = 400,
                    objContentContainerWidth = $(objID).parent().innerWidth();

                if (vm.open_menu) {
                    let contentTargetWidth = objContentContainerWidth - (targetWidth);
                    //close side menu
                    objMenuBlock.css({
                        width: targetWidth + 'px'
                    });

                    slotContentBlock.css({
                        width: contentTargetWidth + 'px'
                    })

                    // treeMenu.css({
                    //     display: 'none'
                    // })
                    //expand content area
                    // slotContentBlock.animate({
                    //     width: contentTargetWidth + 'px'
                    // }, animation_time);

                    objMenuBlock.addClass('closed')
                    vm.open_menu = false;
                } else {
                    // recalculate width based on values, employ split and left and right works unless you change the viewport size i.e open console
                    let left_percent = vm._split,
                        desiredWidth = objContentContainerWidth * left_percent,
                        resetMenuWidth = desiredWidth < 200 ? desiredWidth : 200, //never grow larger than 200
                        resetSlotContentWidth = objContentContainerWidth - (resetMenuWidth);


                    //TODO figure out how to do percentage calculation to fit a second toggle menu
                    //  reset Menu
                    objMenuBlock.css({
                        width: resetMenuWidth + 'px'
                    });


                    // slotContentBlock.css({
                    //     width: resetSlotContentWidth + 'px'
                    // })

                    // treeMenu.css({
                    //     display: 'block'
                    // })

                    //reset slot content
                    // slotContentBlock.animate({
                    //     width: resetSlotContentWidth + 'px'
                    // }, animation_time);

                    objMenuBlock.removeClass('closed')
                    vm.open_menu = true;
                }
            }
        },
        watch: {},
    }
</script>

<style scoped>
    .sideMenuComponent {
        position: relative;
        border-right: 2px solid;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        /*top: 4px;*/
        /*margin-top: -10px;*!*/
        /* margin-bottom: -1px; */
        /*left: -15px;*/
        background: #f8f8f8;
        border-right-color: #b2c6d0;
        min-height: 500px;
        transition: width 0.4s ease-in;
        /* width: 0;*/
    }

    .sideMenuComponent.closed .sideThinHeaderMenu {
        padding-left: 0px;
    }

    #side-menu li.sideThinHeaderMenu {
        z-index: 1;
    }

    #side-menu a:not(.sideThinHeaderMenuLink):not(.sideDeepHeaderMenuLink):not(.sideDeepHeaderSubMenuLink):not(.sideDeepLastLink) {
        z-index: 1;
    }

    .sideThinHeaderMenu i {
        background-color: white;
        color: #003F51;
    }

    .activeNav .sideThinHeaderMenu i {
        background-color: #003F51;
        color: white;
    }

    /*.sideMenuComponent div.sideMenuHeader:focus{*/
    /*    transition-duration: 0.5s;*/
    /*    transition-timing-function: ease-in;*/
    /*    transition-delay: 0.3s;*/
    /*}*/
    .sideMenuComponent .closed {
        width: 33px;
        /*transition: left 2s;*/
    }
    .container.mainContainer {
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-align-items: stretch;
        -moz-align-items: stretch;
        -ms-flex-line-pack: stretch;
        align-items: stretch;
    }
    .container.mainContainer .sideMenuComponent {
        -webkit-flex: 0 1 auto;
        -moz-flex: 0 1 auto;
        -ms-flex: 0 1 auto;
        flex: 0 1 auto;
        /* flex-grow flex-shrink, flex-basis */
        /*-webkit-transition: all 0.4s ease-in-out;*/
        /*-moz-transition: all 0.4s ease-in-out;*/
        /*transition: all 0.4s ease-in-out;*/
    }
    .container.mainContainer .contentOuter {
        -webkit-flex: 1 1 80%;
        -moz-flex: 1 1 80%;
        -ms-flex: 1 1 80%;
        flex: 1 1 80%;
    }
</style>
